import React from 'react';
import PropTypes from 'prop-types';
import GenericError from './GenericError';
import NavigationHistory from '../../libs/NavigationHistory';

/**
 * Show the server state errors on an event detail.
 */

const EventDetailError = ({ errorCode = '', navigationHistory }) => {
  return (
    <GenericError
      message401={i18n('You are not allowed to view this event.')}
      message403={i18n('You are not allowed to view this event.')}
      message404={i18n('This event could not be found.')}
      navigationHistory={navigationHistory}
      errorCode={errorCode}
    />
  );
};

EventDetailError.propTypes = {
  errorCode: PropTypes.oneOf(['', 400, 401, 403, 404, 429, 502, 503]),
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default EventDetailError;
